<template>
    <div>
        <div class="success row-flex row-center-center row-column">
            <img src="../../assets/newImg/success.png" class="success" alt="" />
            <div
                class="text-color"
                style="font-size:20px;font-weight:600;margin-top:-30px"
            >
                兑换成功
            </div>
        </div>
        <div style="height:20px"></div>
        <div class="suc-inter">
            <div class="li row-flex row-between-center">
                <div class="li-left">兑换积分</div>
                <div class="li-right">{{ exchange }}</div>
            </div>
        </div>
        <div style="height:10px"></div>
        <div class="suc-inter">
            <div class="li row-flex row-between-center">
                <div class="li-left">剩余积分</div>
                <div class="li-right">{{ integral }}</div>
            </div>
        </div>
        <div style="height:10px"></div>
        <div class="back row-flex row-around-center">
            <div class="back-home text-color border-color" @click="goPages(1)">
                返回首页
            </div>
            <div class="back-order bg-color" @click="goPages(2)">查看订单</div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.success {
    img {
        width: 134px;
        height: 132px;
    }
}
.suc-inter {
    margin: 0 10px;
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 1px 5px 0px rgba(157, 157, 157, 0.2);
    .li {
        height: 40px;
        padding: 0 11px;

        div {
            font-size: 14px;
            color: #333333;
        }
    }
}
.income {
    height: 298px;
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 1px 5px 0px rgba(157, 157, 157, 0.2);
    margin: 0 10px;
    .title {
        height: 44px;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
    }
    .month {
        .month-title {
            padding-left: 11px;
            font-size: 14px;
        }
    }
    .table {
        margin: 11px;
        table {
            // width: auto;
            border: 1px solid #dec1c1;
            tr {
                width: 100%;
                text-align: center;
                height: 36px;
                line-height: 36px;
                th {
                    font-size: 14px;
                    font-weight: 600;
                }
                td {
                    color: #333;
                    font-size: 12px;
                }
            }
        }
    }
}
.progress {
    height: 120px;
    background: #f8f8f8;
    border-radius: 4px;
    margin: 0 9px;
    padding: 0 15px;
    .pro-top {
        height: 60px;
        .top-left {
            height: 20px;
            line-height: 20px;
            text-align: center;
            color: #ffffff;
            background: linear-gradient(270deg, #f9e9ea, #d01112 10%);
            border-radius: 2px;
            padding: 0 6px;
            width: fit-content;
            font-size: 10px;
            font-weight: 600;
        }
        .top-right {
            font-size: 13px;
            color: #333333;
        }
    }

    .bottom {
        height: 50px;
        font-size: 16px;
    }
}
.back {
    margin: 22px auto;
    div {
        width: 160px;
        height: 50px;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: 600;
    }
    .back-order {
        color: #ffffff;
    }
}
</style>
<script>
import { vipSpeed, getUser } from "@api/user";
const NAME = "PayMentStatus";

export default {
    name: NAME,
    props: {},
    data: function() {
        return {
            integral: 0,
            exchange: 0,
            orderId: "",
        };
    },

    mounted() {
        this.getUser();
    },
    methods: {
        getUser() {
            getUser().then((res) => {
                this.integral = res.data.integral;
                this.exchange = this.$route.query.number;
                this.orderId = this.$route.query.id;
            });
        },
        goPages(e) {
            return this.$router.push({
                path: e == 1 ? "/" : "/order/detail/" + this.orderId,
            });
        },
    },
};
</script>
